<main class="app__main">
    <!-- <app-modal-component *ngIf="openModal" [lat]='lat' [lng]='lng' [address]='address' [cities]='cities' [currentCityId]="currentCityId"></app-modal-component> -->
    <app-home [cities]='cities' [agreed]='agreed' [disagreed]='disagreed'></app-home>
    <app-navbar></app-navbar>
</main>